import React, {MouseEventHandler} from "react"
import styles from "./button.module.scss"
import {GreenUpColor, mapGreenUpColorToCssClass} from "../../util/greenup-colors/green-up-color"
import {combineClasses} from "../../util/class-utils"

export type ButtonStyle = "text" | "primary" | "secondary" | "tertiary" | "colorCode"
export type ButtonSize = "xsmall" | "small" |"normal"

const ButtonStyleMapping: { [t in ButtonStyle]: string } = {
  "primary": styles.Primary,
  "secondary": styles.Secondary,
  "tertiary": styles.Tertiary,
  "colorCode": styles.ColorCode,
  "text": ""
}

const ButtonSizeMapping: { [t in ButtonSize]: string } = {
  "xsmall": styles.ButtonSizeXSmall,
  "small": styles.ButtonSizeSmall,
  "normal": styles.ButtonSizeNormal,
}

interface ButtonProps {
  onClick: MouseEventHandler<HTMLElement>
  buttonStyle?: ButtonStyle
  buttonSize?: ButtonSize
  disabled?: boolean
  color?: GreenUpColor
  colorCode?: string
}

export const Button: React.FC<ButtonProps> = ({onClick, buttonStyle = "text", buttonSize = "normal", disabled = false, children, color, colorCode}) => {
  if (buttonStyle === "text") {
    const classNames = combineClasses([
      styles.TextButton,
      (color === undefined) ? undefined : mapGreenUpColorToCssClass(color)
    ])

    return <span className={classNames} onClick={(e) => {if (!disabled) onClick(e)}}>{children}</span>
  } else {
    const classNames = combineClasses([
      ButtonStyleMapping[buttonStyle],
      ButtonSizeMapping[buttonSize],
      (color === undefined) ? undefined : mapGreenUpColorToCssClass(color)
    ])

    return <button disabled={disabled} onClick={onClick} className={classNames} style={(colorCode === undefined ? undefined : {backgroundColor: colorCode})}>{children}</button>
  }
}

